module.exports = __webpack_public_path__ + "img/BannerProHome1.f0a47d1a.webp";